<template>
  <v-form v-model="form.valid">
    <v-card max-width="700" class="mx-auto">
      <v-toolbar color="teal" dark>
        <v-icon class="toolbar-title-icon">mdi-card-plus</v-icon>
        <v-toolbar-title>Nieuwe iRC licentie</v-toolbar-title>
      </v-toolbar>
      <v-sheet>
        <v-container>
          <v-menu min-width="auto">
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Aantal"
                v-model="form.input.amount"
                :rules="form.rules.amountRules"
              />
              <v-text-field
                v-on="on"
                label="Verloopdatum"
                prepend-icon="mdi-calendar"
                :value="form.input.expirationDate"
                readonly
              />
            </template>
            <v-date-picker
              v-model="form.input.expirationDate"
              :min="new Date().toISOString().slice(0, 10)"
            />
          </v-menu>
          <v-btn
            :disabled="!form.valid"
            color="primary"
            @click="createNewLicense"
            :loading="form.loading"
            >Aanmaken</v-btn
          >
        </v-container>
      </v-sheet>
    </v-card>
  </v-form>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory";

export default {
  name: "NewIRCLicenseForm",
  data() {
    return {
      form: {
        valid: false,
        loading: false,
        input: {
          amount: 1,
          expirationDate: undefined
        },
        rules: {
          amountRules: [
            v => !!v || "Dit veld is verplicht",
            v => !isNaN(v) || "Voer een getal in",
            v => v > 0 || "Voer een getal groter dan 0 in",
            v => Number.isInteger(Number(v)) || "Voer een geheel getal in"
          ]
        }
      }
    };
  },
  methods: {
    createNewLicense() {
      this.form.loading = true;
      let orgId = this.$route.params["organisation"];
      RepositoryFactory.get("ircLicenses")
        .store({
          expiration_date: this.form.input.expirationDate,
          organisation_id: orgId,
          amount: this.form.input.amount
        })
        .then(() => {
          this.$emit("licenseCreated");
        })
        .catch(() => {
          this.$store.dispatch(
            "notifications/addFeedbackNotification",
            "feedback.licenses.error"
          );
        })
        .finally(() => {
          this.form.loading = false;
        });
    }
  },
  computed: {
    oneYear() {
      let nextYear = new Date();
      nextYear.setFullYear(nextYear.getFullYear() + 1);
      return nextYear.toISOString();
    }
  }
};
</script>

<style scoped>

</style>
